import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { initLenis, destroyLenis } from "@/lib/scroll";
import { initClickTracking } from "@/lib/analytics";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Ribbon from "@/components/Marquee";
import Services from "@/components/Services";
import Equipment from "@/components/Equipment";
import Calculator from "@/components/Calculator";
import Manifesto from "@/components/Manifesto";
import Testimonials from "@/components/Testimonials";
import Faq from "@/components/Faq";
import QuoteForm from "@/components/QuoteForm";
import Footer from "@/components/Footer";
import StickyBar from "@/components/StickyBar";
import CookieConsent from "@/components/CookieConsent";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

const HomePage = () => {
  const [prefill, setPrefill] = useState(null);

  useEffect(() => {
    initLenis();
    initClickTracking();
    return () => destroyLenis();
  }, []);

  return (
    <div className="bg-[#F7F9FC] text-slate-900 min-h-screen">
      <div className="noise-overlay" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <Ribbon />
        <Services />
        <Equipment />
        <Calculator onApply={setPrefill} />
        <Manifesto />
        <Testimonials />
        <Faq />
        <QuoteForm prefill={prefill} />
      </main>
      <Footer />
      <StickyBar />
      <CookieConsent />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/confidentialite" element={<PrivacyPolicy />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
